document.addEventListener('DOMContentLoaded', () => {
  function initializeSlick() {
    $('.compare-slide-container').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      dots: true,
      centerMode: false,
      swipeToSlide: true,
      draggable: true,
      swipe: true,
      touchThreshold: 10,
      swipeToSlide: true,
      prevArrow:
        '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
      nextArrow:
        '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
      customPaging: function (slider, i) {
        var imageBefore = slider.$slides.eq(i).find('img').first().data('src');
        return '<button type="button"><img src="' + imageBefore + '" alt="Dot image" class="dot-image"/></button>';
      },
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
  initializeSlick();
});